import { render, staticRenderFns } from "./BalanceDetailsModal.vue?vue&type=template&id=69b752b6&scoped=true"
import script from "./BalanceDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalanceDetailsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BalanceDetailsModal.vue?vue&type=style&index=0&id=69b752b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b752b6",
  null
  
)

export default component.exports